import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { alert } from 'devextreme/ui/dialog';
import { ComponentService } from '../../../../services/component.service';
import { Apiservice } from '../../../../services/api.service';
import { IModelloStampa, ModelliStampaService } from '../../../../services/modelli-stampa.service';
import { saveAs } from 'file-saver';

interface fileXml {
  fileName: string;
  content: string;
}

@Component({
  selector: 'app-popup-esportazione-files',
  templateUrl: './popup-esportazione-files.component.html',
  styleUrls: ['./popup-esportazione-files.component.css']
})
export class PopupEsportazioneFilesComponent implements OnInit {
  @Input() reletedData
  @Input() guid
  buttonCustomsBottomToolbar = [
    {
      id: 'genera',
      text: 'Genera',
      icon: 'dx-icon-export',
      disabled: false,
      visible: true,
      name: 'genera',
      location: 'after',
      widget: 'button'
    }
  ];
  radioDataPdf = [
    {
      value: 'esportaPdf',
      descrizione: 'Esporta in un file PDF le operazioni completate'
    },
  ]
  radioDataXml = [
    {
      value: 'esportaXmlRentri',
      descrizione: 'Esporta file XML con firma tecnica Rentri'
    },
    // {
    //   value: 'esportaXmlDh',
    //   descrizione: 'Esporta file XML con firma tecnica Dh Waste'
    // },
  ]
  disabled = false
  dataSet = {
    azione: null,
    daData: null,
    aData: null
  }
  modelloRegistroRentri
  private moment = require('moment');
  constructor(private componentService: ComponentService, private apiService: Apiservice, private modelliStampaService: ModelliStampaService) { }
  ngOnInit(): void {
    this.apiService.GetApi(`ModellodiStampa/GetByGUID/bb33baa2-fe89-467d-885d-fdcd3a547bfa`).then((data: IModelloStampa) => {
      this.modelloRegistroRentri = data || null
      console.log('modelloRegistroRentri', data)
    });
  }
  async emittendButtonPush(event) {
    if (this.dataSet.azione === null) {
      return alert('Selezionare un tipo di esportazione', 'Attenzione');
    }
    if (this.dataSet.azione && this.dataSet.azione === 'esportaPdf') {
      if (this.dataSet['daData'] === null || this.dataSet['adata'] === null) {
        return alert('Selezionare un range di date', 'Attenzione');
      }
      const isDaDataValid = this.moment(this.dataSet['daData']).isValid();
      const isADataValid = this.moment(this.dataSet['aData']).isValid();
      if (!isDaDataValid || !isADataValid) {
        return alert('Le date inserite non sono valide', 'Attenzione');
      }
      const intervalloCorretto = this.moment(this.dataSet['daData']).isSameOrBefore(this.moment(this.dataSet['aData']));
      if (!intervalloCorretto) return alert('L\'intervallo di date non è corretto', 'Attenzione');
      this.stampaInterna()
    } else if (this.dataSet.azione && this.dataSet.azione === 'esportaXmlRentri') {
      try {
        const res = await this.apiService.GetApi(`renesportazioni/GetXMLUnicoConFirmaRentri?idRegistro=${this.reletedData.id}`) as fileXml;
        const blob = new Blob([res.content], { type: 'application/xml' });
        saveAs(blob, res.fileName);
      } catch (error) {
        console.log(error)
        alert('Errore durante la generazione del file XML', 'Attenzione')
      }
    }
  }
  onValueChangedRadio(event) {
    console.log('onValueChangedRadio', event)
    if (event && event.value && event.value !== "esportaPdf") this.disabled = true
    else this.disabled = false
  }

  //! -------------------------------------------------------------
  private async stampaInterna() {
    const data = this.dataSet;
    if (!data) return alert('Errore nei dati', 'Attenzione');
    const api = 'RenRegistrazioni/GetRenRegistrazioniListPerStampa'
    const query = `?idRegistro=${this.reletedData['id']}&dallaData=${data['daData']}&allaData=${data['aData']}`
    if (!api || !query) return alert('Errore durante la generazione della stampa', 'Attenzione');
    try {
      this.apiService.GetApi(api + query).then((datiPdf: []) => {
        if (!datiPdf || datiPdf.length === 0) return alert('Nessun dato da stampare', 'Attenzione')
        if (!this.modelloRegistroRentri) return alert('Modello di stampa non presente', 'Attenzione')

        this.modelliStampaService.generaPDF(datiPdf, this.modelloRegistroRentri, 'preview').then((id) => {
          this.componentService.outputComponent.subscribe(currentOutput => {
            if (currentOutput.guid == id) {
              console.log('currentOutput--->', currentOutput)
              if (currentOutput.name == "close") {
                this.componentService.destroyCurrentOpenPopUpByGuid(id);
                this.componentService.destroyOutputComponent();
              }
            }
          })
        })
      }).catch((error) => {
        throw new Error('Errore durante la generazione della stampa: ' + error);
      })
    } catch (error) {
      console.log(error)
      alert('Errore durante la generazione della stampa', 'Attenzione')
    }
  }
}